import React, { useContext, useEffect, useState } from 'react'
import { errorSchema, utils } from 'helper';
import { CommonInput, CommonModal, CommonSwitch, CommonTextarea, CustomSelect } from 'components'
import StorageService from 'utils/StorageServices/StorageServices';
import toast, { Toaster } from 'react-hot-toast';
import { createMaterialCategory } from '_services/materialServices/materialCategoryServices';
import { podReceivedData, updateLrProcess, uploadFiles } from '_services';
import { RiAddLargeFill } from "react-icons/ri";
import { createZone } from '_services/accountsServices/zoneServices';
import { createVehicleGroup } from '_services/accountsServices/vehicleGroupServices';
import { createVehicleDocType, editVehicleDocType } from '_services/accountsServices/vehicleDocTypeServices';
import { createStore, editStore } from '_services/workShopServices/workShopServices';
import { createFirmBank, updateFirmBank } from '_services/accountsServices/firmServices';

const formObj = {
    company_id: StorageService.getCompanyId(),
    firm_id: StorageService.getFirmId(),
    account_number: '',
    bank_name: '',
    ifsc_code: '',
    branch_name: '',
    print_on_invoice: true
}

const AddEditFirmBankModel = (props) => {

    const { isOpen, closeModal, callListApi = () => { } } = props;
    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);

    let editCondition = isOpen?._id && isOpen?.isDetails === false;
    let viewCondition = isOpen?._id && isOpen?.isDetails === true;

    const handleSearch = async (ifscCode) => {
        // Fetch bank details from Razorpay IFSC API
        const validateIFSC = (code) => {
            const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
            return ifscRegex.test(code.toUpperCase());
        };
        const valid = validateIFSC(ifscCode);
        if (valid) {
            try {
                const res = await fetch(`https://ifsc.razorpay.com/${ifscCode}`);
                if (!res.ok) {
                    return res
                }
                const data = await res.json();
                return data
            } catch (err) {
                toast.error(err.message);
            }
        }
    };

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        if (name === "ifsc_code" && value.length === 11) {
            try {
                const bankDetails = await handleSearch(value);
                if (bankDetails && bankDetails.BRANCH) {
                    stateObj.bank_name = bankDetails.BANK;
                    stateObj.branch_name = bankDetails.BRANCH;
                    // stateObj.branch_code = bankDetails.BANKCODE;
                    // stateObj.city_name = bankDetails.CITY;
                    // stateObj.state_name = bankDetails.STATE;
                } else {
                    stateObj.bank_name = "";
                    stateObj.branch_name = "";
                    setFormError(prev => ({
                        ...prev,
                        ifsc_code: "invalid IFSC code",
                    }));
                }
            } catch (error) {
                stateObj.bank_name = "";
                stateObj.branch_name = "";
            }
        }
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.addEditFirmBankSchema);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const apiCallingFunction = async () => {
        try {
            if (isOpen?._id) {
                let obj = {
                    ...formValue,
                    firm_id: formValue?.firm_id,
                    bank_id: isOpen?._id,
                };
                const res = await updateFirmBank(obj)
                if (res?.responseCode == 200) {
                    setFormValue({});
                    setLoading(false);
                    if (res?.responseMessage) {
                        toast.success(res?.responseMessage);
                    }
                    callListApi()
                    closeModal(false);
                } else {
                    setLoading(false);
                    if (res?.responseMessage) {
                        toast.error(res?.responseMessage);
                    }
                }
            } else {
                let obj = { ...formValue }
                const res = await createFirmBank(obj);
                if (res?.responseCode == 200) {
                    setFormValue({});
                    setLoading(false);
                    if (res?.responseMessage) {
                        toast.success(res?.responseMessage);
                    }
                    callListApi();
                    closeModal(false);
                } else {
                    setLoading(false);
                    if (res?.responseMessage) {
                        toast.error(res?.responseMessage);
                    }
                }
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const handleClick = async (value) => {
        const validationResult = await utils?.checkFormError(formValue, errorSchema.addEditFirmBankSchema);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            setLoading(true);
            apiCallingFunction();
            setFormError("");
        } else {
            setFormError(validationResult);
        }
    }

    let inhanceProps = {
        ...props,
        submitTitle: loading ? 'Loading...' : props.submitTitle,
        disabled: loading,
        onSubmit: handleClick,
    }

    useEffect(() => {
        setFormValue((s) => ({
            ...s,
            company_id: StorageService.getCompanyId(),
            firm_id: StorageService.getFirmId(),
        }))
    }, [])

    useEffect(() => {
        if (editCondition === true) {
            setFormValue((s) => ({
                ...s,
                company_id: isOpen?.company_id ? isOpen?.company_id : StorageService.getCompanyId(),
                firm_id: isOpen?.firm_id ? isOpen?.firm_id : StorageService.getFirmId(),
                account_number: isOpen?.account_number,
                bank_name: isOpen?.bank_name,
                ifsc_code: isOpen?.ifsc_code,
                branch_name: isOpen?.branch_name,
                print_on_invoice: isOpen?.print_on_invoice,
            }))
        }
        if (viewCondition === true) {
            setFormValue((s) => ({
                ...s,
                company_id: isOpen?.company_id ? isOpen?.company_id : StorageService.getCompanyId(),
                firm_id: isOpen?.firm_id ? isOpen?.firm_id : StorageService.getFirmId(),
                account_number: isOpen?.account_number,
                bank_name: isOpen?.bank_name,
                ifsc_code: isOpen?.ifsc_code,
                branch_name: isOpen?.branch_name,
                print_on_invoice: isOpen?.print_on_invoice,
            }))
        }
    }, [editCondition, viewCondition])

    return (
        <div>
            <CommonModal {...inhanceProps}>
                <div className='addItem_body mt-2'>
                    <div className='colFlx'>
                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                placeholder="Ex.123456789012345"
                                label="Account Number"
                                name="account_number"
                                onChange={({ target: { name, value } }) => {
                                    if (/^\d*$/.test(value)) {
                                        handleOnChange(name, value);
                                    }
                                }}
                                maxLength={20}
                                value={formValue?.account_number}
                                focus={!!formError?.account_number}
                                error={formError.account_number}
                                disabled={viewCondition ? true : false}
                            />
                        </div>
                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                placeholder="Bank Name"
                                label="Bank Name"
                                name="bank_name"
                                value={formValue?.bank_name}
                                maxLength={50}
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                                focus={!!formError?.bank_name}
                                error={formError.bank_name}
                                disabled={viewCondition ? true : false}
                            />
                        </div>
                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                placeholder="Ex.SBIN0000000"
                                label="IFSC Code"
                                name="ifsc_code"
                                value={formValue?.ifsc_code}
                                maxLength={11}
                                onChange={({ target: { name, value } }) => {
                                    const upperLatter = value.toUpperCase();
                                    handleOnChange(name, upperLatter)
                                }}
                                focus={!!formError?.ifsc_code}
                                error={formError.ifsc_code}
                                disabled={viewCondition ? true : false}
                            />
                        </div>
                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                placeholder="Branch Name"
                                label="Branch Name"
                                name="branch_name"
                                value={formValue?.branch_name}
                                maxLength={50}
                                onInput={utils.maxLengthCheck}
                                onChange={(e) => utils.handleNameInputChange(e, handleOnChange)}
                                focus={!!formError?.branch_name}
                                error={formError.branch_name}
                                disabled={viewCondition ? true : false}
                            />
                        </div>
                        <div className="singleDiv _pMode_exbx px-3">
                            <CommonSwitch
                                id="print_on_invoice"
                                name="print_on_invoice"
                                label="Print on Invoice"
                                value={formValue?.print_on_invoice}
                                checked={formValue?.print_on_invoice}
                                disabled={viewCondition ? true : false}
                                onChange={({ target: { name, checked } }) => {
                                    handleOnChange(name, checked ? true : false);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </CommonModal>
        </div>
    )
}

export default AddEditFirmBankModel